var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "insights" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _c("svg-icon", {
          staticClass: "mr-5",
          attrs: { "icon-name": "dashboard-insights", size: 16 },
        }),
        _c("span", [_vm._v(_vm._s(_vm.$t("clientDashboard.insights")))]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "__content" },
      [
        _vm._l(_vm.dataList, function (item, index) {
          return [
            _c(
              "div",
              {
                key: index,
                staticClass: "item",
                on: {
                  click: function ($event) {
                    return _vm.openLink(item.linkUrl)
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "date",
                  style: { background: _vm.colorList[index % 3] },
                  domProps: { innerHTML: _vm._s(item.date) },
                }),
                _c(
                  "div",
                  { staticClass: "info" },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: item.name, placement: "top" } },
                      [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                      ]
                    ),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(_vm._s(item.desc)),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }